



function submenuHoverOpenV2() {

    if( $(".mainitms-tpl-m7").length ){

        var itemMenu                    = ".mainitms-tpl-m7 .sminner-m7";
        var itemMenuFirstChild          = ".sminner-m7:first-child";
        var totalItemsSubmenu           = ".mainitms-tpl-m7 .msmin-m7 .smcontt-m7";
        var itemMenushow                = "show-m7";
        var itemMenuMain                = ".mainitms-tpl-m7 .mictn-m7>ul>li.subm-m7 .mittl-m7";
        var itemMenuMainParent          = ".mainitms-tpl-m7 .subm-m7";
        var itemMenuMainParentHover     = ".mainitms-tpl-m7 .subm-m7:hover";
        var subMenuActived              = ".mainitms-tpl-m7 .misubmnu-m7";
        var subSubMenuActived           = ".mainitms-tpl-m7 .sbinitms-m7";
        var itemMenuMainActived         = "actived-m7";
        var header                      = ".header-tpl-m7";
        var headerShowSubmenu           = "smenushow-m7";
        var body                        = "body";
        var menuShow                    = "showmenu-m7";
        var backdrop                    = ".subackdrop-m7";
        var totalSubmenuItems           = ".mainitms-tpl-m7 .sbiinner-m7>ul";

        var buttonSubmenuInner          = ".mainitms-tpl-m7 .subm-m7 .js-togglesbitm-m7";
        var buttonSubmenuInnerParent    = ".pnlsi-m7";
        var haveSubmenuInner            = "havesbitm-m7";
        var buttonSubmenuMain           = ".mainitms-tpl-m7 .subm-m7 .sbitm-m7";

        var deviceWidthCollapse;


        //calculate and setting height for submenu when openning
        var heightSubmenuPc = function(evt){

            // $(evt.currentTarget).addClass("ddddddd");
            var totalItemsSubmenuThis  = $(evt.currentTarget).find(".smcontt-m7");
            var subSubMenuActivedThis  = $(evt.currentTarget).find(".sbinitms-m7");
            var subMenuActivedThis     = $(evt.currentTarget).find(".misubmnu-m7");
            var countItem              = $(evt.currentTarget).find(".smcontt-m7 .sminner-m7").length;
            // console.log("countItem : " + countItem);
            // var sumHeightTittleSubmenu = $(totalItemsSubmenuThis).height() - 34;
            // var sumHeightTittleSubmenu = $(totalItemsSubmenuThis).height()  ;
            var sumHeightTittleSubmenu = countItem * 50  ;
            var maxHeightCategoryItems = 0;

            // $('.mainitms-tpl-m7 .sminner-m7 .sbinitms-m7').each(function() {
            $(subSubMenuActivedThis).each(function() {
                if ($(this).height() > maxHeightCategoryItems) {
                    maxHeightCategoryItems = $(this).height();
                }
            });
        }


        //baz shodan daste bandi mahsoul dar zirmenu
        $( itemMenu ).mouseenter(function() {

            if( $(this).siblings().hasClass(itemMenushow) ){
                $(this).siblings().removeClass(itemMenushow);
                $( this ).addClass(itemMenushow);
            }

            else{
                $( this ).addClass(itemMenushow);
            }
        });


        //prevent openning submenu whit onclick on tittle products in menu
        $(document).on('click', itemMenuMain , function(event) {

            if ($(window).width() >= 992){
                // event.preventDefault();
            }
        });


        //openning submenu whit mousehover on tittle products in menu
        $( itemMenuMainParent ).mouseenter(function(evt) {

            if ($(window).width() >= 992){


                setTimeout( function(){

                    if ($('.misubmnu-m7:hover').length != 0) {
                    }

                    else{

                        if( $( this ).hasClass(itemMenuMainActived) ){
                            mouseLeaveMenuItme();
                        }
                    }
                    // } ,3000);
                } ,300);

                if( $( itemMenuMainParent ).hasClass(itemMenuMainActived) ){
                    $(backdrop).detach();
                }
                else{
                    $(header).addClass(headerShowSubmenu);
                    $(body).addClass(menuShow);
                }


                if( $( this ).hasClass(itemMenuMainActived) ){

                }

                else{
                    $("body").append('<div class="subackdrop-m7"></div>');
                    $( this ).addClass(itemMenuMainActived);
                }

                $( itemMenuMainParent ).removeClass(itemMenuMainActived);
                $( ".sinsubm-m7" ).removeClass("show-m7");

                $( this ).addClass(itemMenuMainActived);
                // $( this ).find(itemMenuFirstChild).addClass(itemMenushow);
                $(header).addClass(headerShowSubmenu);
                $(body).addClass(menuShow);
                heightSubmenuPc(evt);

                if( $(this).find(".sbinitms-m7").length){
                    $( itemMenuMainParent ).removeClass("hassubm2-m7")
                    $(this).addClass("hassubm2-m7")
                }
            }
        });


        $( itemMenuMainParent ).click(function(evt) {

            if ($(window).width() >= 992 && $(window).width() < 1199){

                // if( $( itemMenuMainParent ).hasClass(itemMenuMainActived) ){
                //     $(backdrop).detach();
                // }

                if( $( this ).hasClass(itemMenuMainActived) ){
                    // mouseLeaveMenuItme();

                }

                else{
                    $("body").append('<div class="subackdrop-m7"></div>');
                    $( itemMenuMainParent ).removeClass(itemMenuMainActived);
                    $( this ).addClass(itemMenuMainActived);
                    // $( this ).find(itemMenuFirstChild).addClass(itemMenushow);
                    $(header).addClass(headerShowSubmenu);
                    $(body).addClass(menuShow);
                }

                heightSubmenuPc(evt);

                if( $(this).find(".sbinitms-m7").length){
                    $( itemMenuMainParent ).removeClass("hassubm2-m7")
                    $(this).addClass("hassubm2-m7")
                }
            }

            else{
            }
        });


        // $(document).mouseup(function (e){

        //     if ($(window).width() >= 992 && $(window).width() < 1199){

        //         var container = $(".header-tpl-s1"); // Give you class or ID

        //         if (!container.is(e.target) &&            // If the target of the click is not the desired div or section
        //             container.has(e.target).length === 0) // ... nor a descendant-child of the container
        //         {
        //             mouseLeaveMenuItme(e);
        //         }
        //     }
        // });



        //closing submenu whit mouseleave from tittle products in menu

        var mouseLeaveMenuItme = function(){

            $(itemMenuMainParent).removeClass( itemMenuMainActived );
            $(header).removeClass(headerShowSubmenu);
            $(backdrop).detach();
            $(body).removeClass(menuShow);
            $( itemMenuMainParent ).removeClass("hassubm2-m7");
            $(itemMenu).removeClass(itemMenushow);
        }


        $( itemMenuMainParent ).mouseleave(function(){

            if ($(window).width() >= 992){

                if ($(itemMenuMainParentHover).length != 0) {
                    $( this ).addClass(itemMenuMainActived);
                    $(header).addClass(headerShowSubmenu);
                    $(body).addClass(menuShow);
                }

                else{
                    mouseLeaveMenuItme();
                    $(subMenuActived).collapse('hide');
                }
            }
        });



        //jeloye baz shadan collapse zir menu dar size tablet ra migirad
        $(itemMenu).mouseover(function(e){
            // if ($(window).width() >= 992){
            if ($(window).width() >= 992){
                e.preventDefault();
                e.stopPropagation();
            }
        });



        //dar size kamtar az 992px collapse kar mikonad va link kar nemikonad . va dar size bishtar az 992px collapse kar nemikonad va link kar mikonad
        var preventLinkSubmenu = function(){

            //baraye zirmenu asli
            $(".mainitms-tpl-m7 .subm-m7 .smttl-m7.js-prvntlnk-m7").click(function() {

                if ($(window).width() < 992){
                    return false;
                }
                else{
                    return true;
                }
            });


            $(".mainitms-tpl-m7 .subm-m7 .smttl-m7.js-prvntlnk-m7").click(function() {

                // if ($(window).width() < 992){
                // if ($(window).width() < 992){
                if ($(window).width() < 992){
                    $( this ).siblings(subSubMenuActived).collapse('toggle');
                }
                else{
                    $('.smttl-m7.js-prvntlnk-m7').attr('data-toggle', '');
                }
            });


            //baraye zirmenu zirshakheh
            $(buttonSubmenuInner).click(function() {

                // if ($(window).width() < 992 ){
                if ($(window).width() < 992 ){
                    if($(this).parent(buttonSubmenuInnerParent).hasClass(haveSubmenuInner)){
                        return false;
                    }
                }
                else{
                    return true;
                }
            });


            $(buttonSubmenuMain).click(function() {

                // if ($(window).width() < 992){
                if ($(window).width() < 992){
                    $( this ).siblings(".subsbitms-m7").collapse('toggle');
                }
                else{
                    $('.sbitm-m7').attr('data-toggle', '');
                }
            });
        };


        preventLinkSubmenu();


        function resizeLinkSubmenu(){
            // Haven't resized in 100ms!

            deviceWidthCollapse = $(window).width();
            // if( deviceWidthCollapse < 992){
            if( deviceWidthCollapse < 992){
                preventLinkSubmenu();
            }
            else{

            }
        }


        // if ($(window).width() >= 992){
        if ($(window).width() >= 992){
            $(itemMenuMain).attr("data-toggle","");
        }
        else{
            $(itemMenuMain).attr("data-toggle","collapse");
        }


        function resizedwCollapse(){
            // Haven't resized in 100ms!

            deviceWidthCollapse = $(window).width();

            // if( deviceWidthCollapse >= 992){
            if( deviceWidthCollapse >= 992){

                if( $(subMenuActived).hasClass("in") ){
                    $(subMenuActived).collapse('hide');
                }

                if( $(subSubMenuActived).hasClass("in") ){
                    $(subSubMenuActived).collapse('hide');
                }

                $(itemMenuMain).attr("data-toggle","");
            }
            else{
                $(itemMenuMain).attr("data-toggle","collapse");
            }
        }


        function resizeheightSubmenu(){
            // Haven't resized in 100ms!

            deviceWidthCollapse = $(window).width();
            if( deviceWidthCollapse >= 992){

                // heightSubmenuPc();
            }
            else{
                // heightSubmenuMob();
            }
        }


        var heightSubmenu;
        var doitCollapse;
        var doitLink;

        window.onresize = function(){
            clearTimeout(doitCollapse);
            doitCollapse = setTimeout(resizedwCollapse, 300);

            clearTimeout(heightSubmenu);
            heightSubmenu = setTimeout(resizeheightSubmenu, 300);

            clearTimeout(doitLink);
            doitLink = setTimeout(resizeLinkSubmenu, 300);
        };
    }
}








export {submenuHoverOpenV2};
